import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		inputMultipleFile_section: {
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
		},
		inputMultipleFile_divBreak: {
			margin: '5px 0px',
		},
		inputMultipleFile_fileNameBody: {
			display: 'flex',
			flexDirection: 'row',
		},
		inputMultipleFile_fileNameTextBody: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			wordBreak: 'break-all',
		},
		inputMultipleFile_uploadIcon: {
			width: '2em',
			height: '2em',
		},
		inputMultipleFile_dragAndDropBox: {
			height: '100%',
			justifyContent: 'center',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			padding: '20px',
			borderWidth: '2px',
			borderRadius: '2px',
			borderStyle: 'dashed',
			color: theme.palette.grey[400],
			outline: 'none',
		},
		inputMultipleFile_dragAndDropBoxBorder: {
			borderColor: theme.palette.grey[300],
		},
		inputMultipleFile_dragAndDropBoxBorderError: {
			borderColor: theme.palette.error.main,
		},
		inputMultipleFile_dragEnter: {
			backgroundColor: theme.palette.background.default,
			transition: `${theme.transitions.duration.standard}ms ease-in-out`,
		},
		inputMultipleFile_dragLeave: {
			backgroundColor: theme.palette.grey[100],
			transition: `${theme.transitions.duration.standard}ms ease-in-out`,
		},
		inputMultipleFile_deleteBtn: {
			padding: '0px',
			color: 'inherit',
			marginLeft: '10px',
		},
		inputMultipleFile_messageBody: {
			display: 'flex',
			flexDirection: 'row'
		},
		inputMultipleFile_messageTextBody: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		inputMultipleFile_label: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		inputMultipleFile_helperText: {
			color: theme.palette.info.main,
			fontSize: '12px',
			fontWeight: 400,
			lineHeight: '1.66',
			letterSpacing: '0.03333em',
		},
		inputMultipleFile_helperTextError: {
			color: theme.palette.error.main,
			fontSize: '12px',
			fontWeight: 400,
			lineHeight: '1.66',
			letterSpacing: '0.03333em',
		},
		inputMultipleFile_inputBtnWrapper: {
			marginLeft: '5px',
			flex: '1 0 auto',
		},
		inputMultipleFile_inputBtn: {
			position: 'relative',
			'& > input': {
				position: 'absolute',
				top: '0',
				right: '0',
				left: '0',
				bottom: '0',
				width: '100%',
				margin: '0',
				padding: '0',
				opacity: 0,
				height: '100%'
			},
		}
	});
});

export default useStyles;